import { formatDate } from '@angular/common';
import { ElementRef, SimpleChanges, ViewChild } from '@angular/core';
import { OnChanges } from '@angular/core';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { element } from '@angular/core/src/render3/instructions';
import { ToastrService } from 'ngx-toastr';
import { timer } from 'rxjs/internal/observable/timer';
import { Subscription } from 'rxjs/internal/Subscription';
import { SmartAppUtilities } from 'src/app/models/common/getjsonfrom-controls-service-model';
import { ResOrderDetails } from 'src/app/models/Restaurant/ResOrderDetails.model';
import { ResOrders } from 'src/app/models/Restaurant/ResOrders.model';
import { NumericSanitizerPipe } from 'src/app/pipes/numeric-sanitizer.pipe';
import { findArrayMax, sortArray } from 'src/app/services/common-methods/common-methods-exports';
import { LoaderService } from 'src/app/services/loader/LoaderService';
import { RestaurantService } from 'src/app/services/restaurant/restaurant.service';
import { WebsocketService } from 'src/app/services/restaurant/websocket.service';
import { BusinessServices } from 'src/app/services/singleton/business-services';
import { ApplicationCodes, CommonConstant } from 'src/app/shared/constent/applicationcodes';
import { DateFormatterPipe } from 'src/app/shared/custom-pipes/date-formatter.pipe/date-formatter.pipe';
import { TranslatePipe } from 'src/app/shared/custom-pipes/translate-pipe/translate.pipe';
import { SanitizeValueFormatter } from 'src/app/value-formatters/sanitize-value-formatter';
import { Globals } from 'src/environments/Globals';
declare var $: any;
declare var qz: any;  // declare QZ Tray global variable

@Component({
  selector: 'app-kitchen',
  templateUrl: './kitchen.component.html',
  styleUrls: ['./kitchen.component.css']
})

export class KitchenComponent implements OnInit, OnDestroy {
  @ViewChild('printFrame') printFrame: ElementRef;
  pendingOrdersList = new Array<ResOrders>();
  // pendingOrdersList = Observable<Array<ResOrders>>;
  inProgressOrdersList = new Array<ResOrders>();
  completedOrdersList = new Array<ResOrders>();
  commonconstant = new CommonConstant();
  model: ResOrders = new ResOrders();
  godownData: any[];
  timeName: string = "";
  timeValue: number = -1440;
  ascDesc: number = 1;

  goDowmCode: any = "";
  goDownName: any = "";
  printTime: any = "";
  printerName: any = "";
  CompanyLogo: any = "";
  CompanyCode: any = "";
  companyMobile: any = "";
  companyFax: any = "";
  vatNumber: string = "";
  CompanyAddress: string = "";
  companyname: string = "";
  screen: string = '2';
  showMainContent: Boolean = false;
  OrderCode: string = '';
  CompletionTime: string = '';
  Status: number = null;
  orderType: string = '';
  TimeRequired: number = null;
  domainURL: string = '';
  applicationCodes = new ApplicationCodes();

  subscription: Subscription;
  intervalSubscription: Subscription;
  companySymbol: string = '';
  printWindow: Window | null = null;

  orderModel: ResOrders = new ResOrders();
  tableList: any[] = [];
  paymentMethod: any[] = [];
  orderTypes = [
    { id: 1, name: this.translate.transform('3634') },
    { id: 2, name: this.translate.transform('3635') },
    { id: 3, name: this.translate.transform('999') }
  ];
  jsonObject: any[] = [];
  newRecordIndex: number = 1;
  numRows: number;
  rows: number = 4;
  isUpdate: boolean = false;
  isGenerateBill: boolean = false;
  smartUtilities = new SmartAppUtilities(this.toastrService);
  printModel: ResOrders = new ResOrders();
  public url = '/api/ProductCardMaster/PROC_ProductCardNames_ForPurchase/2/1';
  public base_url = '/api/ProductCardMaster/PROC_ProductCardNames_ForPurchase/2/';
  public params_search = {};

  totalSum: number = 0;
  selectedPaymentType: string = '';

  isLoading = false;

  notifications: Array<Notification> = new Array<Notification>();
  totalUnreadNotifications: number = 0;
  
  constructor(private globals: Globals, private toastrService: ToastrService, private translate: TranslatePipe, private numericSanitizerPipe: NumericSanitizerPipe,
    private restaurantService: RestaurantService, private businessService: BusinessServices, private dateFormat: DateFormatterPipe, private svf: SanitizeValueFormatter,
    private el: ElementRef, private loaderService: LoaderService, private socketService: WebsocketService) {
    this.domainURL = window.location.origin;
  }

  ngOnInit() {

    this.socketService.connect('wss://devsocket.nuktaerp.com/ws');

    // this.socketService.getMessages().subscribe((msg) => {
    //   // this.socketService.push(msg);
    // });

    this.bindOrdersListings(this.goDowmCode, this.timeValue);

    this.businessService.commonService.Get(this.applicationCodes.GodownTableName + ',' + this.applicationCodes.ResTables + ',' + this.applicationCodes.PaymentMethods).subscribe((data: any) => {
      this.godownData = data.filter(x => x.TblName == this.applicationCodes.GodownTableName);
      this.tableList = data.filter(x => x.TblName == this.applicationCodes.ResTables);
      this.paymentMethod = data.filter(x => x.TblName == this.applicationCodes.PaymentMethods);
    });

    $(document).click(function () {
      $("#notfidrop").hide();
    });

    $(".bellicon").click(function (e) {
      e.stopPropagation();
      $("#notfidrop").show();
    });

    $("body").addClass("kitchenbody");

    this.updateNotificationsListFromStorage()

    if (this.globals.getDataFromLocalStorage(this.commonconstant.CompanyName) != null && this.globals.getDataFromLocalStorage(this.commonconstant.CompanyName) != "") {
      this.companyname = this.globals.getDataFromLocalStorage(this.commonconstant.CompanyName);
    }

    if (this.globals.getDataFromLocalStorage(this.commonconstant.PrinterName) != null && this.globals.getDataFromLocalStorage(this.commonconstant.PrinterName) != "") {
      this.printerName = this.globals.getDataFromLocalStorage(this.commonconstant.PrinterName);
    }

    if (this.globals.getDataFromLocalStorage(this.commonconstant.CompanyAddress) != null && this.globals.getDataFromLocalStorage(this.commonconstant.CompanyAddress) != "") {
      this.CompanyAddress = this.globals.getDataFromLocalStorage(this.commonconstant.CompanyAddress);
    }

    if (this.globals.getDataFromLocalStorage(this.commonconstant.CompanyLogo) != null && this.globals.getDataFromLocalStorage(this.commonconstant.CompanyLogo) != ",") {
      this.CompanyLogo = this.globals.getDataFromLocalStorage(this.commonconstant.CompanyLogo);
    }

    if (this.globals.getDataFromLocalStorage(this.commonconstant.MobileNo) != null && this.globals.getDataFromLocalStorage(this.commonconstant.MobileNo) != ",") {
      this.companyMobile = this.globals.getDataFromLocalStorage(this.commonconstant.MobileNo);
    }

    if (this.globals.getDataFromLocalStorage(this.commonconstant.ContactNumber) != null && this.globals.getDataFromLocalStorage(this.commonconstant.ContactNumber) != ",") {
      this.companyFax = this.globals.getDataFromLocalStorage(this.commonconstant.ContactNumber);
    }
    
    if (this.globals.getDataFromLocalStorage(this.commonconstant.CompanyLogo) != null && this.globals.getDataFromLocalStorage(this.commonconstant.CompanyLogo) != ",") {
      this.CompanyLogo = this.globals.getDataFromLocalStorage(this.commonconstant.CompanyLogo);
    }

    if (this.globals.getDataFromLocalStorage(this.commonconstant.CompanyCurrencySymbol)) {
      this.companySymbol = this.globals.getDataFromLocalStorage(this.commonconstant.CompanyCurrencySymbol);
    }

    if (this.globals.getDataFromLocalStorage(this.commonconstant.LoggedInCompanyID)) {
      this.CompanyCode = this.globals.getDataFromLocalStorage(this.commonconstant.LoggedInCompanyID);
    }

    this.vatNumber = this.globals.getDataFromLocalStorage(this.commonconstant.CompanyVatNumber);

    setInterval(() => {
      this.countDownTime();
      this.orderCountDown();
    }, 1000);
  }

  /* modal box plus minus toggle */
  quantity: number = 0;
  i = 0;
  plus() {
    if (this.i != 0) {
      this.i++;
      this.quantity = this.i
    }
    else {
      this.quantity = 1;
      this.i = 1;
    }
  }
  minus() {
    if (this.i != 1) {
      this.i--;
      this.quantity = this.i
    }
  }

  closePopUp() {
    this.i = 0;
    this.quantity = 0;
  }

  toggle() {
    if (this.screen == '1') {
      this.showMainContent = true;
    }
    else {
      this.showMainContent = false;
    }
  }

  onGoDownChange(value) {
    var selectedItem = this.godownData.find(x => x.code == value);
    if (selectedItem == null || selectedItem == undefined)
      selectedItem = this.godownData.find(x => x.name.toLowerCase() == value.toLowerCase());
    if (selectedItem) {
      this.goDowmCode = selectedItem.code;
      this.goDownName = selectedItem.name;
    }
    else {
      this.goDowmCode = "";
      this.goDownName = "";
    }
    this.bindOrdersListings(this.goDowmCode, this.timeValue);
  }

  onOrderTypeChange(value) {

    var selectedItem = this.orderTypes.find(x => x.id == value);
    if (selectedItem == null || selectedItem == undefined)
      selectedItem = this.orderTypes.find(x => x.name.toLowerCase() == value.toLowerCase());
    if (selectedItem) {

      this.orderModel.OrderType = selectedItem.id;
      this.orderModel.OrderTypeName = selectedItem.name;
    }
    else {
      this.orderModel.OrderType = null;
      this.orderModel.OrderTypeName = "";
    }
  }

  onTableChange(value) {
    var selectedItem = this.tableList.find(x => x.code == value);
    if (selectedItem == null || selectedItem == undefined)
      selectedItem = this.tableList.find(x => x.name.toLowerCase() == value.toLowerCase());
    if (selectedItem) {
      this.orderModel.TableCode = selectedItem.code;
    }
    else {
      this.orderModel.TableCode = "";
    }
  }

  onPaymentMethodChange(value) {

    var selectedItem = this.paymentMethod.find(x => x.code == value);
    if (selectedItem == null || selectedItem == undefined)
      selectedItem = this.paymentMethod.find(x => x.name.toLowerCase() == value.toLowerCase());
    if (selectedItem) {
      this.orderModel.PaymentMode = selectedItem.code;
      this.orderModel.PaymentName = selectedItem.name;
    }
    else {
      this.orderModel.TableCode = "";
      this.orderModel.PaymentName = "";
    }
  }

  openNewOrderModel() {
    this.jsonObject = [];
    this.orderModel = new ResOrders();
    this.orderModel.TimeRequired = 30;
    this.orderModel.Status = 1;
    this.orderModel.IsPaid = false;
    this.newRecordIndex = 1;
    this.orderModel.IsInserting = true;
    this.isUpdate = false;
    this.isGenerateBill = false;
    this.defaultRows(this.rows);
  }

  updateOrder(order: any) {

    this.jsonObject = [];
    this.orderModel = new ResOrders();
    this.newRecordIndex = 1;
    this.orderModel = order;
    this.orderModel.IsInserting = false;
    this.orderModel.Status = 1;
    this.isUpdate = true;
    this.isGenerateBill = false;
    this.loadDataGrid(order.ResOrderDetailList);
    this.defaultRows(this.rows);
  }

  selectPaymentType(type: string) {
    this.selectedPaymentType = type;
    this.orderModel.PaymentName = type; // optional: bind it to your input
    if (type == 'Cash')
      this.orderModel.PaymentMode = '1';
    else if (type == 'Bank')
      this.orderModel.PaymentMode = '2';
    else if (type == 'Transfer')
      this.orderModel.PaymentMode = '3';
  }

  billOrder(order: any) {

    if (!order.IsPaid) {
      this.jsonObject = [];
      this.orderModel = new ResOrders();
      this.orderModel = order;
      this.orderModel.IsInserting = true;
      this.orderModel.Status = 3;
      this.isUpdate = false;
      this.isGenerateBill = true;
      $('#BillModalForm').modal('show');
      this.loadDataGrid(order.ResOrderDetailList);
    }
    else {
      this.toastrService.error(this.translate.transform('3970'));
      setTimeout(() => {
        $('#OrderModalForm').modal('hide');
      }, 1000);
    }

  }

  loadDataGrid(data: any) {
    data.forEach(element => {
      element.SalesPrice = element.Price;
      element.GrandAmount = element.SalesPrice * element.Quantity;
      this.jsonObject.push(element);
    });
    this.refreshUICalculations();
  }

  onTimeFilterChange() {
    this.bindOrdersListings(this.goDowmCode, this.timeValue);
  }

  bindOrdersListings(goDownCode: string, timeValue: number) {

    let date = new Date()
    date = this.dateFormat.transform(new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1, 0, 0, 0, 0), 'yyyy-MM-dd hh:mm:ss');
    let latestDate = this.dateFormat.transform(new Date(), 'yyyy-MM-dd HH:mm:ss');

    this.restaurantService.ordersRepository.GetAllForKitchen(goDownCode, date, date, timeValue, latestDate, this.ascDesc, this.orderType).subscribe(data => {

      if (data._statusCode === 200 && data._obj && data._obj.length > 0) {

        let pendingOrders = data._obj.filter(x => x.Status == 1)
        if (pendingOrders && pendingOrders.length > 0)
          sessionStorage.setItem(this.commonconstant.Last_Pending_Order_Time_kitchen, findArrayMax(pendingOrders, 'OrderRecordTimeStamp').OrderRecordTimeStamp)
        else {
          sessionStorage.setItem(this.commonconstant.Last_Pending_Order_Time_kitchen, date.toString())
        }


        let progressOrders = data._obj.filter(x => x.Status == 2)
        if (progressOrders && progressOrders.length > 0) {
          sessionStorage.setItem(this.commonconstant.Last_Order_Time_Kitchen, findArrayMax(progressOrders, 'OrderRecordTimeStamp').OrderRecordTimeStamp)
        }
        else {
          sessionStorage.setItem(this.commonconstant.Last_Order_Time_Kitchen, date.toString())
        }

        this.pendingOrdersList = pendingOrders;
        this.inProgressOrdersList = progressOrders;
        this.completedOrdersList = data._obj.filter(x => x.Status == 3);

        console.log(this.sortPendingOrders())
      }
      else {
        this.pendingOrdersList = [];
        this.inProgressOrdersList = [];
        this.completedOrdersList = [];
      }
    });

    if (this.intervalSubscription)
      this.intervalSubscription.unsubscribe();



    this.intervalSubscription = timer(10000, 10000).subscribe(x => {

      this.subscription = this.restaurantService.ordersRepository.GetAllForKitchen(goDownCode, this.getLastInProgressOrderTime(), this.getLastPendingOrderTime(), timeValue, latestDate, this.ascDesc, this.orderType)
        .subscribe(data => {

          if (data._statusCode === 200 && data._obj && data._obj.length > 0) {
            let pendingOrders = data._obj.filter(x => x.Status == 1);
            if (pendingOrders && pendingOrders.length > 0) {

              sessionStorage.setItem(this.commonconstant.Last_Pending_Order_Time_kitchen, findArrayMax(pendingOrders, 'OrderRecordTimeStamp').OrderRecordTimeStamp)
              pendingOrders.forEach(element => {

                let orderIndex = this.pendingOrdersList.findIndex(x => x.OrderCode == element.OrderCode)
                if (orderIndex != -1) {
                  this.pendingOrdersList[orderIndex] = element
                  this.showNotification(element, 'UPDATE')
                }
                else {
                  this.pendingOrdersList.push(element)
                  this.showNotification(element)
                  if (this.CompanyCode == '1000000001') {
                    // this.printWindow = window.open("", "Printable Page", "width=360,height=650px");
                    // Call print logic after some time (e.g., after data is loaded)
                    setTimeout(() => {
                      debugger
                      this.model = element;
                      this.totalSum = this.model.ResOrderDetailList.reduce((sum, item) => {
                        return sum + (item.Price * item.Quantity);
                      }, 0);
                      this.printTime = formatDate(new Date(), 'dd-MM-yyyy hh:mm:ss a', 'en-US');
                      this.model.AreaCode = this.printerName;
                      this.model.PrinterName = this.printerName;
                      this.model.CompanyName = this.companyname;
                      this.model.CompanyAddress = this.CompanyAddress;
                      this.model.PhoneNumber = this.companyMobile;
                      this.model.FaxNumber = this.companyFax;
                      // this.printTest(element);
                      this.socketService.sendMessage(JSON.stringify(element));
                      // this.autoPrintReport(element); // now safe to call
                    }, 500); // delay is safe now
                    // this.printReport(element);
                  }
                }
              });
            }


            let progressOrders = data._obj.filter(x => x.Status == 2);
            if (progressOrders && progressOrders.length > 0) {
              sessionStorage.setItem(this.commonconstant.Last_Order_Time_Kitchen, findArrayMax(progressOrders, 'OrderRecordTimeStamp').OrderRecordTimeStamp)
              progressOrders.forEach(element => {
                let orderIndex = this.inProgressOrdersList.findIndex(x => x.OrderCode == element.OrderCode)
                if (orderIndex != -1) {
                  this.inProgressOrdersList[orderIndex] = element
                  if (this.CompanyCode == '1000000001') {
                    this.showNotification(element, 'UPDATE')
                  }
                }
                else {
                  this.inProgressOrdersList.push(element)
                  this.showNotification(element)
                }
              });
            }

            this.completedOrdersList = data._obj.filter(x => x.Status == 3)
          }
        });
    });
  }

  getOrderTotal(orderDetails: any[]): number {
    return orderDetails.reduce((sum, item) => {
      return sum + (item.Price * item.Quantity);
    }, 0);
  }

  autoPrintReport(order: any) {
    this.model = order;
    this.printTime = new Date().toLocaleString(); // or use Angular DatePipe

    this.totalSum = this.model.ResOrderDetailList.reduce((sum, item) => {
      return sum + (item.Price * item.Quantity);
    }, 0);

    const divToPrint = document.getElementById('divReport');
    if (!divToPrint) return;

    const htmlToPrint = `
      <html>
        <head>
          <style>
            html, body { margin: 0; font-family: Arial; }
          </style>
        </head>
        <body>${divToPrint.innerHTML}</body>
      </html>
    `;

    // Create a hidden iframe
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    iframe.style.overflow = 'hidden';
    document.body.appendChild(iframe);

    // Write content to iframe and print when ready
    const iframeDoc = iframe.contentWindow ? iframe.contentWindow.document : null;
    if (!iframeDoc) {
      alert('Unable to access iframe document.');
      return;
    }

    iframeDoc.open();
    iframeDoc.write(htmlToPrint);
    iframeDoc.close();

    // Wait for content to load before printing
    iframe.onload = function () {
      setTimeout(() => {
        if (iframe.contentWindow) {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
        }

        // Remove iframe after printing
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 500);
      }, 200);
    };
  }

  // autoPrintReport(order: any) {
  //   this.model = order;
  //   this.printTime = new Date().toLocaleString(); // use Angular DatePipe if needed

  //   // STEP 1: Prepare the content to print
  //   setTimeout(() => {
  //     const divToPrint = document.getElementById('divReport');
  //     if (!divToPrint) return;

  //     const htmlToPrint = `
  //       <html>
  //         <head>
  //           <style>
  //             html, body { margin: 0; font-family: Arial; }
  //           </style>
  //         </head>
  //         <body>${divToPrint.innerHTML}</body>
  //       </html>
  //     `;
  //     // STEP 2: window.open must be here, directly within the user-initiated event
  //     const printWindow = window.open('', '_blank', 'width=360,height=650');
  //     if (!printWindow) {
  //       alert('Popup blocked. Please allow popups for this site.');
  //       return;
  //     }

  //     printWindow.document.open();
  //     printWindow.document.write(htmlToPrint);
  //     printWindow.document.close();

  //     // STEP 3: Wait a bit, then print
  //     setTimeout(() => {
  //       printWindow.focus();
  //       printWindow.onafterprint = () => {
  //         printWindow.close();
  //       };

  //       printWindow.print();
  //     }, 200);
  //   }, 200); // delay to allow DOM rendering
  // }
  showNotification(order: ResOrders, Operation: string = 'INSERT') {

    let orderMsg = this.translate.transform('505') + ': #' + order.OrderCode + '<br/> ' + this.translate.transform('3632') + ': ' + order.TimeRequired;
    this.toastrService.info(orderMsg,
      Operation === 'INSERT' ? this.translate.transform('3692') : this.translate.transform('3693'),
      {
        timeOut: 1000,
        positionClass: 'toast-bottom-right',
        toastClass: 'custom-Toast'
      }
    );

    let newNotification = new Notification();

    newNotification.OrderCode = order.OrderCode;
    newNotification.TimeRequired = order.TimeRequired;
    newNotification.IsInsertNotification = Operation == "INSERT";
    newNotification.RowIndex = this.notifications.length;
    this.notifications.push(newNotification)

    // Delay added so that div load in view
    setTimeout(() => {

      $("#" + newNotification.OrderCode).addClass("hvr-buzz");
      setTimeout(() => {

        $("#" + newNotification.OrderCode).removeClass("hvr-buzz");
      }, 1500)
    }, 200);

    this.totalUnreadNotifications = this.notifications.filter(x => !x.IsNotificationRead).length;
    this.updateNotificationsInStorage()

  }

  onNotificationClick(clickedNotification: Notification) {

    clickedNotification.IsNotificationRead = true;
    this.totalUnreadNotifications = this.notifications.filter(x => !x.IsNotificationRead).length;

    document.getElementById(clickedNotification.OrderCode).scrollIntoView({ behavior: "smooth" });

    $("#" + clickedNotification.OrderCode).addClass("hvr-buzz");

    setTimeout(() => {
      $("#" + clickedNotification.OrderCode).removeClass("hvr-buzz");
    }, 1500)

    setTimeout(() => {
      $("html, body").animate({ scrollTop: 0 });
    }, 1500);
    this.updateNotificationsInStorage()
  }

  onReadAllNotificationClick() {
    this.notifications.forEach(element => {
      element.IsNotificationRead = true;
    });
    this.updateNotificationsInStorage()
    this.totalUnreadNotifications = 0;
  }

  getLastInProgressOrderTime(): any {

    let orderTime: any = sessionStorage.getItem(this.commonconstant.Last_Order_Time_Kitchen)

    if (!orderTime) {
      orderTime = new Date();
      orderTime = this.dateFormat.transform(new Date(orderTime.getFullYear(), orderTime.getMonth(), orderTime.getDate(), 0, 0, 0, 0), 'yyyy-MM-dd hh:mm:ss');
    }
    return orderTime;
  }

  getLastPendingOrderTime(): any {
    let orderTime: any = sessionStorage.getItem(this.commonconstant.Last_Pending_Order_Time_kitchen)
    if (!orderTime) {
      orderTime = new Date();
      orderTime = this.dateFormat.transform(new Date(orderTime.getFullYear(), orderTime.getMonth(), orderTime.getDate(), 0, 0, 0, 0), 'yyyy-MM-dd hh:mm:ss');
    }
    return orderTime;
  }

  startOrder(orderCode: string, completionTime: string, status: number, timeRequired: number, spliceRecord: boolean = true, updationTime: string = '') {
    this.restaurantService.ordersRepository.UpdateStatus(orderCode, completionTime, updationTime, status, timeRequired).subscribe((data: any) => {
      if (data && data._statusCode == 200) {
        this.toastrService.success(this.translate.transform(data._message));
        if (spliceRecord) {
          if (status == 2) {
            var exist = this.pendingOrdersList.find(x => x.OrderCode === orderCode);
            if (exist) {
              let index = this.pendingOrdersList.indexOf(exist);
              if (index !== -1) {
                this.pendingOrdersList[index].Status = status;
                this.pendingOrdersList[index].CompletionTime = completionTime;
                this.pendingOrdersList[index].RowIndex = this.inProgressOrdersList.length;
                this.inProgressOrdersList.push(this.pendingOrdersList.find(x => x.OrderCode == orderCode));
                this.pendingOrdersList.splice(index, 1);
              }
            }
          }
          else if (status == 3) {
            var exist = this.inProgressOrdersList.find(x => x.OrderCode === orderCode);
            if (exist) {
              let index = this.inProgressOrdersList.indexOf(exist);
              if (index !== -1) {

                this.inProgressOrdersList[index].Status = status;
                this.inProgressOrdersList[index].CompletionTime = completionTime;
                this.inProgressOrdersList[index].RowIndex = this.completedOrdersList.length;
                this.completedOrdersList.push(this.inProgressOrdersList.find(x => x.OrderCode == orderCode));
                this.inProgressOrdersList.splice(index, 1);
              }
            }
            else {
              var existInPending = this.pendingOrdersList.find(x => x.OrderCode === orderCode);
              if (existInPending) {
                let index = this.pendingOrdersList.indexOf(existInPending);
                if (index !== -1) {
                  this.pendingOrdersList[index].Status = status;
                  this.pendingOrdersList[index].CompletionTime = completionTime;
                  this.pendingOrdersList[index].RowIndex = this.completedOrdersList.length;
                  this.completedOrdersList.push(this.pendingOrdersList.find(x => x.OrderCode == orderCode));
                  this.pendingOrdersList.splice(index, 1);
                }
              }
            }
          }
        }
        else {
          if (status == 1) {
            var existInPending = this.pendingOrdersList.find(x => x.OrderCode === orderCode);
            if (existInPending) {
              let indexs = this.pendingOrdersList.indexOf(existInPending);
              if (indexs !== -1) {
                this.pendingOrdersList[indexs].TimeRequired = timeRequired;
              }
            }
          }
          else if (status == 2) {
            var exist = this.inProgressOrdersList.find(x => x.OrderCode === orderCode);
            if (exist) {
              let index = this.inProgressOrdersList.indexOf(exist);
              if (index !== -1) {
                this.inProgressOrdersList[index].TimeRequired = timeRequired;
              }
            }
          }
          this.closePopUp();
          $('.calcplusmodal').hide();
          $('.modal-backdrop').hide();
        }
      }
      else if (data && data._statusCode == 404) {
        this.toastrService.error(this.translate.transform(data._message));
      }
      else {
        this.toastrService.error(this.translate.transform('66'));
      }
    });
  }

  completeOrder(orderCode: string, completionTime: string, status: number, timeRequired: number) {
    var today = new Date();
    completionTime = formatDate(today, 'yyyy-MM-dd hh:mm:ss a', 'en-US');
    this.startOrder(orderCode, completionTime, status, timeRequired);
  }

  IncreaseTime(orderCode: string, completionTime: string, status: number, timeRequired: number) {
    this.OrderCode = orderCode;
    this.CompletionTime = completionTime;
    this.Status = status;
    this.TimeRequired = timeRequired;
  }

  IncreaseOrderTime() {
    this.TimeRequired = this.TimeRequired + this.quantity;
    var today = new Date();
    var updationTime = formatDate(today, 'hh:mm:ss a', 'en-US');
    this.startOrder(this.OrderCode, this.CompletionTime, this.Status, this.TimeRequired, false, updationTime);
  }

  countDownTime() {
    if (this.inProgressOrdersList != null) {
      this.inProgressOrdersList.forEach(element => {
        var currentDate = formatDate(new Date(), 'MM/dd/yyyy', 'en');
        var orderTime = currentDate + ' ' + element.OrderTime;
        var times = new Date(orderTime);
        var tiiimes = times.setMinutes(times.getMinutes() + element.TimeRequired);
        var timeREquired = new Date(tiiimes).getTime();
        var totalTime = Math.floor(timeREquired - new Date().getTime());

        element.Hour = Math.floor((totalTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        element.Minutes = Math.floor((totalTime % (1000 * 60 * 60)) / (1000 * 60));
        element.Seconds = Math.floor((totalTime % (1000 * 60)) / (1000));

        if (element.Hour <= 0 && element.Minutes <= 0 && element.Seconds <= 0) {
          element.Hour = 0;
          element.Minutes = 0;
          element.Seconds = 0;
        }

      });
    }
  }

  orderCountDown() {
    if (this.pendingOrdersList && this.pendingOrdersList.length) {
      const now = new Date().getTime();
      this.pendingOrdersList.forEach(order => {
        const orderCreatedTime = new Date(order.OrderRecordTimeStamp).getTime();

        let diff = now - orderCreatedTime; // elapsed time in ms

        if (diff < 0) {
          // If OrderDateTime is in the future, reset to zero
          diff = 0;
        }

        order.Hour = Math.floor(diff / (1000 * 60 * 60));
        order.Minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        order.Seconds = Math.floor((diff % (1000 * 60)) / 1000);
      });
    }
  }


  //   printReport(order: any) {
  //   this.model = order;
  //   this.printTime = formatDate(new Date(), 'dd-MM-yyyy hh:mm:ss a', 'en-US');

  //   const divToPrint = document.getElementById('divReport');
  //   if (!divToPrint) return;

  //   const style = '<style>html, body { margin: 0; }</style>';
  //   const content = style + divToPrint.outerHTML;

  //   const iframe = this.printFrame.nativeElement as HTMLIFrameElement;
  //   const doc = iframe.contentWindow.document;

  //   doc.open();
  //   doc.write(content);
  //   doc.close();

  //   // Wait for iframe content to load, then print
  //   iframe.onload = () => {
  //     iframe.contentWindow.focus();
  //     iframe.contentWindow.print();
  //   };
  // }

  getTotal(): number {
    return this.model.ResOrderDetailList.reduce((sum, item) => {
      return sum + (item.Price * item.Quantity);
    }, 0);
  }

  printReport(order: any) {
    debugger
    this.model = order;
    this.totalSum = this.model.ResOrderDetailList.reduce((sum, item) => {
      return sum + (item.Price * item.Quantity);
    }, 0);
    this.printTime = formatDate(new Date(), 'dd-MM-yyyy hh:mm:ss a', 'en-US');
    this.model.PrinterName = this.printerName;
    this.model.CompanyName = this.companyname;
    this.model.CompanyAddress = this.CompanyAddress;
    this.model.PhoneNumber = this.companyMobile;
    this.model.FaxNumber = this.companyFax;
    
    this.socketService.sendMessage(JSON.stringify(this.model));
    // var divToPrint = document.getElementById('divBtnReport');
    // console.log(divToPrint.innerHTML, "Html report");
    // this.printTest(order);

    // setTimeout(() => {

    //   var divToPrint = document.getElementById('divBtnReport');
    //   var htmlToPrint = '<style>html, body {margin: 0;}</style>' + divToPrint.outerHTML;
    //   let newWin = window.open("", "Printable Page", "width=360,height=650px");
    //   newWin.document.write(htmlToPrint);
    //   setTimeout(() => { // wait until all resources loaded

    //     newWin.document.close(); // necessary for IE >= 10
    //     newWin.focus(); // necessary for IE >= 10
    //     newWin.print(); // change window to winPrint
    //   }, 100);
    // }, 100);
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    if (this.subscription)
      this.subscription.unsubscribe();

    if (this.intervalSubscription)
      this.intervalSubscription.unsubscribe();
    //   console.log(performance.navigation)
    //   console.log(performance.navigation.type,'navigation Type')
    // // if (performance.navigation.type == 1)
    sessionStorage.removeItem(this.commonconstant.Kitchen_Notifications_List)
  }

  private updateNotificationsInStorage() {
    sessionStorage.removeItem(this.commonconstant.Kitchen_Notifications_List)
    sessionStorage.setItem(this.commonconstant.Kitchen_Notifications_List, this.notifications && this.notifications.length > 0 ? JSON.stringify(this.notifications) : null)
  }

  private updateNotificationsListFromStorage() {
    let obj = sessionStorage.getItem(this.commonconstant.Kitchen_Notifications_List)
    if (obj) {
      this.notifications = JSON.parse(obj)
      this.totalUnreadNotifications = this.notifications.filter(x => !x.IsNotificationRead).length;
    }
  }

  sortPendingOrders() {
    return sortArray(this.pendingOrdersList, 'OrderRecordTimeStamp').reverse();
  }

  sortCompletedOrders() {
    return sortArray(this.completedOrdersList, 'RowIndex').reverse();
  }
  sortInProgressOrders() {
    return sortArray(this.inProgressOrdersList, 'RowIndex')
  }

  sortNotifications() {
    return sortArray(this.notifications, 'RowIndex').reverse();
  }

  defaultRows(rows: number) {
    var data = [];
    for (var i = 1; i <= rows; i++) {
      var newRecord = new ResOrderDetails();
      newRecord.SerialNumber = this.newRecordIndex;
      newRecord.ProductName = '';
      newRecord.Action = 'Save';
      newRecord.Price = 0;
      newRecord.GrandAmount = 0;
      if (this.isUpdate)
        newRecord.IsUpdated = true;

      this.newRecordIndex++;
      data.push(newRecord);
      // if (this.jsonObject && this.jsonObject.length > 0)
      if (this.jsonObject == undefined)
        this.jsonObject = [];

      this.jsonObject.push(newRecord);
    }
    // if (data.length > 0) {
    //     if (this.jsonObject && this.jsonObject.length > 0) {
    //         this.loadDataInGrid(this.jsonObject);
    //     }
    //     else
    //         this.loadDataInGrid(data);
    // }
  }

  gridAddEvent() {
    var newRecord = new ResOrderDetails();
    newRecord.SerialNumber = this.newRecordIndex;
    newRecord.ProductName = '';
    if (this.isUpdate)
      newRecord.IsUpdated = true;

    newRecord.Action = 'Save';
    this.newRecordIndex++;
    this.jsonObject.push(newRecord);
  }

  ClearFormControls() {
    this.orderModel = new ResOrders();
    this.jsonObject = null;
    this.isUpdate = false;
    this.isGenerateBill = false;
    this.newRecordIndex = 1;
    this.defaultRows(this.rows);
    this.bindOrdersListings(this.goDowmCode, this.timeValue);
  }

  onSearchLeave(value, product) {
    if (value == "") {
      this.clearProduct(product);
    }
  }

  refreshUICalculations() {

    this.jsonObject.forEach((node) => { if (node.ProductCode) { this.applyGridCalculations(node) } });
    this.applyFooterCalculations();
  }


  keyPress(event: KeyboardEvent, value) {
    if (event.keyCode === 13 && value != "") {

    }
    else if (event.keyCode === 40 && value != "") {
      this.scrollDown(event);
    }
    else if (event.keyCode === 38 && value != "") {
      this.scrollUp(event);
    }
  }

  scrollDown(event: Event) {
    const dropdownContent = this.el.nativeElement.querySelector('.ta-results');
    if (dropdownContent) {
      const ddActiveItemHeight = $('.ta-results .ta-item.active').offset();
      const ddContentHeight = $('.dropdown-content').offset();
      dropdownContent.scrollTop += ddActiveItemHeight.top - ddContentHeight.top - 20;
      dropdownContent.scroll();
      event.preventDefault();
    }
  }

  scrollUp(event: Event) {
    const dropdownContent = this.el.nativeElement.querySelector('.ta-results');
    if (dropdownContent) {
      const ddActiveItemHeight = $('.ta-results .ta-item.active').offset();
      const ddContentHeight = $('.dropdown-content').offset();
      dropdownContent.scrollTop -= (ddContentHeight.top - ddActiveItemHeight.top) + 20;
      dropdownContent.scroll();
      event.preventDefault();
    }
  }
  //New Simple grid
  handleResultSelected(result, product) {
    if (result && result["ProductCode"] != null && result["ProductCode"] != undefined && result["ProductCode"] != "") {
      product.Quantity = 1;
      product.UnitType = 1;
      product.UnitName = result["UOMName"];
      product.Price = this.svf.priceFormat(result["AverageCostPrice"]);
      product.ProductName = result["Name"];

      product.ProductType = result["ProductType"];
      product.ProductCode = result["ProductCode"];
      product.ProductBarCode = result["ProductBarCode"];
      product.UnitCode = result["UOMCode"];
      product.UnitCode = result["UnitType"];
      product.SalesPrice = result['SalesPrice'];
      product.UnitFragment = result["UnitFragment"];
      product.Action = "Edit";

      setTimeout(() => {
        this.updateValue(product);
        $("#Price" + product.SerialNumber).data('val', this.numericSanitizerPipe.transform(product.Price, 2));
      }, 100);
    }

    $('#Quantity' + product.SerialNumber).focus();
    $('#productSearchPopup').modal('hide');

  }

  clearProduct(product) {

    product.UnitName = "";
    product.PriceType = 1;
    product.ProductName = '';
    product.Price = 0;
    product.UnitType = '';
    product.ProductCode = '';
    product.Quantity = '0';
    product.Amount = 0;
    product.GrandAmount = 0;

    this.refreshUICalculations();
  }

  updateValue(product) {
    this.applyGridCalculations(product);
    this.applyFooterCalculations();
  }

  applyGridCalculations(data: any) {

    if (data.Quantity == 0)
      data.Quantity = 1;

    data.Quantity = this.svf.quantityFormat(data.Quantity);
    data.GrandAmount = this.svf.amountFormat((Number(data.SalesPrice) * data.Quantity)); //price formula for discount
  }

  applyFooterCalculations() {

    this.orderModel.GrandAmount = 0;
    this.orderModel.NetAmount = 0;
    this.jsonObject.forEach((node) => {
      if (node.ProductCode) {
        this.orderModel.GrandAmount += Number(node.GrandAmount);
        this.orderModel.NetAmount += Number(node.GrandAmount);
      }
    });

    this.orderModel.GrandAmount = this.svf.amountFormat(this.orderModel.GrandAmount);

    if (this.orderModel.GlobalDiscountRate != 0) {
      if (this.orderModel.GlobalDiscountRate > 100) {
        this.orderModel.GlobalDiscountRate = 100;
      }
      this.orderModel.GlobalDiscountAmount = ((this.orderModel.GrandAmount * this.orderModel.GlobalDiscountRate) / 100);
      this.orderModel.GlobalDiscountAmount = this.svf.amountFormat(this.orderModel.GlobalDiscountAmount);
    }

    this.orderModel.GlobalDiscountAmount = this.svf.amountFormat(this.orderModel.GlobalDiscountAmount);
    this.orderModel.NetAmount = this.orderModel.GrandAmount - this.orderModel.GlobalDiscountAmount;
    this.orderModel.NetAmount = this.svf.amountFormat(this.orderModel.NetAmount);
  }

  updatePrice(product) {
    var prev = $("#SalesPrice" + product.SerialNumber).data('val');
    var current = $("#SalesPrice" + product.SerialNumber).val();

    if (prev != current) {
      this.updateValue(product);
      $("#SalesPrice" + product.SerialNumber).data('val', this.numericSanitizerPipe.transform(product.SalesPrice, 2));
    }
  }

  createOrder() {
    this.loaderService.display(true);
    var isContinue = true;
    if (!this.orderModel.OrderType) {
      this.toastrService.error(this.translate.transform('3969'));
      isContinue = false;
      return;
    }

    if (this.jsonObject.length == 0) {
      this.toastrService.error(this.translate.transform('1487'));
      isContinue = false;
      return;
    }

    this.orderModel.ResOrderDetailList = [];

    this.jsonObject.forEach(element => {
      if (element.ProductCode) {
        element.Price = element.SalesPrice;
        this.orderModel.ResOrderDetailList.push(element);
      }
    });

    if (isContinue) {
      var reportModel = new ResOrders();
      reportModel = this.orderModel;
      this.restaurantService.ordersRepository.SaveOrder(this.orderModel).subscribe((data: any) => {

        if (data && data._statusCode == 200) {
          $('#OrderModalForm').modal('hide');
          this.toastrService.success(this.translate.transform(data._message));
          // this.printTest(reportModel);


          if (this.CompanyCode == '1000000001') {
            // this.printWindow = window.open("", "Printable Page", "width=360,height=650px");
            if (this.isUpdate)
              reportModel.ResOrderDetailList = reportModel.ResOrderDetailList.filter(x => x.IsUpdated == true);

            console.log(reportModel, "Model");
            setTimeout(() => {
              debugger
              this.model = data._obj;
              this.totalSum = this.model.ResOrderDetailList.reduce((sum, item) => {
                return sum + (item.Price * item.Quantity);
              }, 0);
              this.printTime = formatDate(new Date(), 'dd-MM-yyyy hh:mm:ss a', 'en-US');
              this.model.PrinterName = this.printerName;
              this.model.CompanyName = this.companyname;
              this.model.CompanyAddress = this.CompanyAddress;
              this.model.PhoneNumber = this.companyMobile;
              this.model.FaxNumber = this.companyFax;
              this.socketService.sendMessage(JSON.stringify(this.model));
              // this.printReceipt();
              // this.model.AreaCode = this.printerName;
              // this.printTest(reportModel);
              // this.autoPrintReport(reportModel); // now safe to call
            }, 500); // delay is safe now
          }
          this.ClearFormControls();
        }
        else {
          this.toastrService.error(this.translate.transform(data._message));
        }
        this.loaderService.display(false);
      });
    }
    this.loaderService.display(false);
  }


  // ----------------QZ TRAY-----------------//
  async connect() {
    try {
      await qz.websocket.connect();
      console.log("Connected to QZ Tray");
    } catch (error) {
      console.error("Failed to connect to QZ Tray:", error);
    }
  }

  onPrint() {


    // const receiptText = `
    //   Store XYZ
    //   ---------------------
    //   Item 1     $10.00
    //   Item 2     $5.00
    //   ---------------------
    //   Total      $15.00
    // `;
    this.printReceipt();
  }

  async printReceipt() {
    try {
      if (!qz.websocket.isActive()) {
        await this.connect();
      }

      const receiptText = document.getElementById('divBtnReport');

      const htmlContent = `
    <html>
      <head>
        
      </head>
      <body>
        ${receiptText.innerHTML}
      </body>
    </html>
  `;

      const printData = [{
        type: 'html',
        format: 'plain',
        data: htmlContent
      }];

      debugger

      const printers = await qz.printers.find();
      console.log("Available printers:", printers);

      if (printers.length === 0) {
        throw new Error("No printers found.");
      }

      var pName = printers.indexOf("EPSON TM-T88III Receipt");
      const printerName = printers[pName];
      const config = qz.configs.create(printerName);
      await qz.print(config, printData);

      // printers.forEach(element => {
      //   if(element.Name == "EPSON TM-T88III Receipt"){
      //    printerName =
      //   }
      // });

      // or a specific printer you want to use

      // if()
      // console.log("Using printer:", printerName);

      console.log("Print job sent!");
    } catch (error) {
      console.error("Print error:", error);
    }
  }

  disconnect() {
    qz.websocket.disconnect();
  }

  //-------------------------QZ TRAY END---------------//

  printTest(order: any) {
    debugger
    // this.model = order;
    const reportElement = document.getElementById('divBtnReport');
    var html = reportElement ? reportElement.innerHTML : '';
    this.printModel.AreaName = html;
    // this.printModel.AreaName = reportElement.innerHTML;
    this.restaurantService.ordersRepository.PrintReport(this.printModel).subscribe((data: any) => {
      if (data && data._statusCode == 200) {

      }
      else {
        this.toastrService.error(this.translate.transform(data._message));
      }
      this.toastrService.success(this.translate.transform(data._message));
      this.loaderService.display(false);
    });
  }

  createBill() {
    debugger
    this.isLoading = true;
    var isContinue = true;

    this.orderModel.GoDownCode = (this.goDowmCode == undefined || this.goDowmCode == "") ? this.godownData[0].code : this.goDowmCode;
    this.orderModel.ResOrderDetailList = [];
    this.orderModel.IsPaid = true;

    if (!this.orderModel.PaymentMode) {
      this.toastrService.error('Payment is required.');
      isContinue = false;
      return;
    }

    this.jsonObject.forEach(element => {
      if (element.ProductCode) {
        element.Price = element.SalesPrice;
        this.orderModel.ResOrderDetailList.push(element);
      }
    });

    if (isContinue) {
      this.restaurantService.ordersRepository.SaveBill(this.orderModel).subscribe((data: any) => {
        if (data && data._statusCode == 200) {
          $('#BillModalForm').modal('hide');
          this.ClearFormControls();
          var isContinue = false;
          this.toastrService.success(this.translate.transform(data._message));
        }
        else {
          var isContinue = false;
          this.toastrService.error(this.translate.transform(data._message));
        }
        this.isLoading = false;
      });
    }
    this.isLoading = false;
  }
}
export class Notification {
  constructor() {
    this.IsNotificationRead = false;
  }
  RowIndex: number;
  OrderCode: string;
  TimeRequired: number;
  IsNotificationRead: boolean;
  IsInsertNotification: boolean;
}
